import { render, staticRenderFns } from "./CargoCategory.vue?vue&type=template&id=2f3870a7&scoped=true&"
import script from "./CargoCategory.vue?vue&type=script&lang=js&"
export * from "./CargoCategory.vue?vue&type=script&lang=js&"
import style0 from "./CargoCategory.vue?vue&type=style&index=0&id=2f3870a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3870a7",
  null
  
)

export default component.exports